































import {Component, Vue} from "vue-property-decorator";
import Client from "@/app/Http/Client";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";

@Component({
    components: {LoadingOverlay, LoadSpinner}
})
export default class PasswordForgot extends Vue {
    private email: string = '';

    private async requestEmail() {
        this.resetFlash();
        await this.task<void>(async () => {
            await Client.post('/password/email', {email: this.email});

            this.flash(
                this.$t('Er is een mail verstuurd, hiermee kan u uw wachtwoord opnieuw instellen'),
                5000
            );
        });
    }
}
